import React, { Component } from 'react';
import PropTypes from 'prop-types';
import _ from 'lodash';
import { DropdownButton, MenuItem } from 'react-bootstrap';
import clearIconBlue from '../../images/clear-field-icon_b.png';
import searchIcon from '../../images/search-icon.png';

class CommonDropdown extends Component {
  constructor(props) {
    super(props);
    this.state = {
      ddListVisible: false,
      selectedListItem: this.props.defaultSelected !== undefined ?
      this.props.defaultSelected : undefined,
      listItems: this.props.listData !== undefined ? this.props.listData : [],
      tempListItems: this.props.listData !== undefined ? this.props.listData : [],
      searchText: '',
    };
  }

  UNSAFE_componentWillReceiveProps(nextProps) {
    if (this.props.listData !== nextProps.listData) {
      this.setState({
        listItems: nextProps.listData,
        tempListItems: nextProps.listData,
      });
    }
    if (this.props.defaultSelected !== nextProps.defaultSelected) {
      this.setState({
        selectedListItem: nextProps.defaultSelected,
      });
    }
  }

  itemClick = item => {
    const curSelectedItem = this.state.selectedListItem;
    if (!_.isEqual(item, curSelectedItem)) {
      this.setState({
        ddListVisible: false,
        selectedListItem: item,
      });
      this.props.itemClickFn(item);
    } else {
      this.setState({
        ddListVisible: false,
      });
    }
  }

  handleOnChange = () => {
    const { tempListItems, listItems, searchText } = this.state;
    this.setState({ searchText: this.searchBox.value }, () => {
      if (this.searchBox.value.length > 0) {
        this.handleSearch();
      } else if (tempListItems !== listItems) {
        this.setState({
          listItems: _.cloneDeep(tempListItems),
        });
      }
    });
  }

  handleSearch = () => {
    const { tempListItems, searchText } = this.state;
    const filteredList = _.filter(tempListItems, data => (
      _.includes(_.toLower(data.label), _.toLower(searchText))
    ));
    this.setState({
      listItems: filteredList,
    });
  }

  handleOnClear = () => {
    const { tempListItems } = this.state;
    this.setState({
      searchText: '',
      listItems: _.cloneDeep(tempListItems),
    }, () => {
      if (this.searchBox) {
        this.searchBox.value = '';
      }
    });
  }

  render() {
    const { placeHolder, filterSearch,disabled } = this.props;
    const { selectedListItem, listItems, searchText, tempListItems } = this.state;
    return (
      <div className="common-select-dropdown">
        <DropdownButton
          className={selectedListItem === undefined && 'place-holder'}
          title={selectedListItem && selectedListItem !== '' ? selectedListItem.label : placeHolder}
          id="selectSubEntitiesList"
          show={this.state.ddListVisible}
          disabled={disabled}
          onToggle={() =>
            this.setState({
              ddListVisible: !this.state.ddListVisible,
            })
          }
        >
          {filterSearch &&
            <div className="search-bar">
              <button
                type="button"
                className="button"
                style={{ cursor: 'initial' }}
              >
                <img src={searchIcon} alt="search" />
              </button>
              <input
                type="text"
                placeholder="Search..."
                defaultValue={searchText}
                onChange={this.handleOnChange}
                ref={searchBox => { 
                  this.searchBox = searchBox;
                }}
              />
              <button
                type="button"
                className="button"
                onClick={this.handleOnClear}
                style={{ display: `${searchText.length > 1 ? 'block' : 'none'}` }}
              >
                <img src={clearIconBlue} alt="clear" />
              </button>
            </div>}
          <li>
            {listItems.length > 0 ? <ul className="menu-list">
              {_.map(listItems, o => (
                o.label !== undefined && <li
                  key={o.value}
                  onClick={() => this.itemClick(o)}
                >{o.label}</li>
              ))}
            </ul> : (
              <span className="display-block padding-10">
                No Result Found. {`${tempListItems.length !== 0 ? 'Please refine your search.' : ''}`}
              </span>
            )}
          </li>
        </DropdownButton>
      </div>
    );
  }
}

CommonDropdown.propTypes = {
  listItems: PropTypes.shape({}),
  defaultSelected: PropTypes.shape({}),
  itemClickFn: PropTypes.func,
  placeHolder: PropTypes.string,
  filterSearch: PropTypes.bool,
};

export default CommonDropdown;
